import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function ExosomePage() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-24 pb-16 bg-gradient-to-br from-purple-600 to-pink-600 text-white overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: 'url(https://public.readdy.ai/ai/img_res/fe9b2f2bb9113ec70becdd251807e6a4.jpg)'
          }}
        ></div>
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            エクソソーム（エキソソーム）の力で<br />美しさを革新
          </h1>
          <p className="text-xl md:text-2xl mb-8 opacity-95">
            幹細胞由来エクソソーム（エキソソーム）が切り開く、次世代美容・医療技術
          </p>
        </div>
      </section>

      {/* What is Exosome Section */}
      <section className="py-20 bg-gradient-to-br from-gray-50 to-purple-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800">
                エクソソーム（エキソソーム）とは
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                エクソソーム（エキソソーム）は、細胞から分泌される30-150nm程度の微小な細胞外小胞です。細胞間コミュニケーションの重要な役割を担い、<strong>タンパク質、miRNA、成長因子</strong>などの生理活性物質を運搬します。
              </p>
              <p className="text-lg text-gray-700 mb-8 leading-relaxed">
                特に<strong>幹細胞由来のエクソソーム（エキソソーム）</strong>は、細胞の修復・再生を促進する豊富な成分を含有しており、美容・医療分野での応用が期待されています。
              </p>
              
              <div className="grid grid-cols-2 gap-6">
                <div className="bg-white rounded-xl p-6 shadow-lg">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                    <i className="ri-microscope-line text-2xl text-purple-600"></i>
                  </div>
                  <h3 className="text-lg font-bold mb-2 text-gray-800">サイズ</h3>
                  <p className="text-sm text-gray-600">30-150nm<br />ナノレベルの微小粒子</p>
                </div>
                
                <div className="bg-white rounded-xl p-6 shadow-lg">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                    <i className="ri-dna-line text-2xl text-purple-600"></i>
                  </div>
                  <h3 className="text-lg font-bold mb-2 text-gray-800">成分</h3>
                  <p className="text-sm text-gray-600">タンパク質・miRNA<br />成長因子など</p>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="w-full h-96 overflow-hidden rounded-2xl shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=Detailed%20scientific%20illustration%20of%20exosome%20structure%20and%20cellular%20communication%20process%2C%20extracellular%20vesicles%20transferring%20between%20stem%20cells%2C%20advanced%20microscopy%20visualization%20of%20exosome%20membrane%20proteins%20and%20RNA%20contents%2C%20modern%20biomedical%20research%20showing%20exosome%20biogenesis%20pathway%2C%20clean%20white%20laboratory%20background%20with%20sophisticated%20imaging%20equipment%20and%20molecular%20biology%20diagrams&width=600&height=400&seq=exosome-structure-diagram-2024&orientation=landscape"
                  alt="エクソソーム（エキソソーム）構造"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            幹細胞由来エクソソーム（エキソソーム）の美容・医療効果
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-pink-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-pulse-line text-3xl text-pink-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">細胞再生促進</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                成長因子やサイトカインが細胞の修復・再生プロセスを活性化し、組織の若返りを促進します。
              </p>
              <ul className="text-left text-sm text-gray-600 space-y-2">
                <li className="flex items-center"><i className="ri-checkbox-circle-fill text-pink-500 mr-2"></i>コラーゲン産生促進</li>
                <li className="flex items-center"><i className="ri-checkbox-circle-fill text-pink-500 mr-2"></i>線維芽細胞活性化</li>
                <li className="flex items-center"><i className="ri-checkbox-circle-fill text-pink-500 mr-2"></i>創傷治癒促進</li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-time-line text-3xl text-blue-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">アンチエイジング</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                細胞レベルでの老化プロセスを遅延させ、肌の弾力性とハリを改善します。
              </p>
              <ul className="text-left text-sm text-gray-600 space-y-2">
                <li className="flex items-center"><i className="ri-checkbox-circle-fill text-blue-500 mr-2"></i>シワ・たるみ改善</li>
                <li className="flex items-center"><i className="ri-checkbox-circle-fill text-blue-500 mr-2"></i>肌質改善</li>
                <li className="flex items-center"><i className="ri-checkbox-circle-fill text-blue-500 mr-2"></i>色素沈着軽減</li>
              </ul>
            </div>
            
            <div className="bg-gradient-to-br from-teal-50 to-green-50 rounded-xl p-8 text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">治療効果向上</h3>
              <p className="text-gray-700 text-sm leading-relaxed mb-4">
                医療分野では、既存治療法の効果を高める補完的な役割を果たします。
              </p>
              <ul className="text-left text-sm text-gray-600 space-y-2">
                <li className="flex items-center"><i className="ri-checkbox-circle-fill text-teal-500 mr-2"></i>炎症抑制効果</li>
                <li className="flex items-center"><i className="ri-checkbox-circle-fill text-teal-500 mr-2"></i>組織修復促進</li>
                <li className="flex items-center"><i className="ri-checkbox-circle-fill text-teal-500 mr-2"></i>免疫調整作用</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Section */}
      <section className="py-20 bg-gradient-to-br from-purple-50 to-pink-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            Exosome Oneの先進エクソソーム（エキソソーム）技術
          </h2>
          
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
            <div>
              <img
                src="https://readdy.ai/api/search-image?query=Advanced%20exosome%20extraction%20and%20purification%20laboratory%20with%20ultracentrifuge%20machines%20and%20chromatography%20equipment%2C%20scientists%20in%20white%20coats%20operating%20sophisticated%20isolation%20systems%20for%20stem%20cell%20derived%20exosomes%2C%20modern%20biotechnology%20facility%20with%20automated%20purification%20processes%2C%20clean%20sterile%20environment%20with%20blue%20LED%20lighting%20and%20quality%20control%20testing%20apparatus&width=600&height=384&seq=exosome-extraction-lab-2024&orientation=landscape"
                alt="エクソソーム抽出・精製"
                className="w-full h-96 object-cover rounded-2xl shadow-xl"
              />
            </div>
            <div>
              <h3 className="text-2xl font-bold mb-6 text-gray-800">
                高純度エクソソーム（エキソソーム）抽出・精製技術
              </h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                Exosome Oneは、独自の<strong>多段階精製プロセス</strong>により、高純度・高活性なエクソソーム（エキソソーム）の抽出を実現しています。
              </p>
              
              <div className="space-y-4">
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <span className="inline-flex items-center justify-center w-8 h-8 bg-purple-600 text-white rounded-full font-bold text-sm">1</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">幹細胞培養</h4>
                    <p className="text-gray-600 text-sm">自動培養ロボットによる最適条件での幹細胞大量培養</p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <span className="inline-flex items-center justify-center w-8 h-8 bg-purple-600 text-white rounded-full font-bold text-sm">2</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">上清液回収</h4>
                    <p className="text-gray-600 text-sm">培養上清からエクソソーム（エキソソーム）含有培地を無菌的に回収</p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <span className="inline-flex items-center justify-center w-8 h-8 bg-purple-600 text-white rounded-full font-bold text-sm">3</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">精製・濃縮</h4>
                    <p className="text-gray-600 text-sm">超遠心分離・クロマトグラフィーによる高純度精製</p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="flex-shrink-0">
                    <span className="inline-flex items-center justify-center w-8 h-8 bg-purple-600 text-white rounded-full font-bold text-sm">4</span>
                  </div>
                  <div>
                    <h4 className="font-bold text-lg mb-2">品質管理</h4>
                    <p className="text-gray-600 text-sm">電子顕微鏡・フローサイトメトリーによる品質確認</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            エクソソーム（エキソソーム）の応用分野
          </h2>
          
          <div className="grid lg:grid-cols-2 gap-12">
            <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-8">
              <div className="mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Luxury%20cosmetic%20skincare%20laboratory%20with%20exosome-based%20beauty%20products%20development%2C%20scientists%20formulating%20advanced%20anti-aging%20serums%20and%20creams%20with%20stem%20cell%20derived%20ingredients%2C%20modern%20cosmetics%20manufacturing%20facility%20with%20sophisticated%20testing%20equipment%2C%20elegant%20product%20bottles%20and%20containers%20in%20clean%20white%20laboratory%20setting%20with%20professional%20lighting&width=600&height=256&seq=exosome-cosmetics-lab-2024&orientation=landscape"
                  alt="化粧品応用"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">美容・化粧品分野</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                エクソソーム（エキソソーム）を配合したスキンケア製品により、従来の化粧品を超えた効果を実現
              </p>
              
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h4 className="font-bold text-lg mb-2 text-pink-600">アンチエイジングクリーム</h4>
                  <p className="text-sm text-gray-600">シワ・たるみの改善、肌弾力向上</p>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h4 className="font-bold text-lg mb-2 text-pink-600">修復美容液</h4>
                  <p className="text-sm text-gray-600">肌荒れ・ニキビ跡の改善、バリア機能強化</p>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h4 className="font-bold text-lg mb-2 text-pink-600">ブライトニング製品</h4>
                  <p className="text-sm text-gray-600">色素沈着改善、透明感向上</p>
                </div>
              </div>
            </div>
            
            <div className="bg-gradient-to-br from-teal-50 to-blue-50 rounded-2xl p-8">
              <div className="mb-6">
                <img
                  src="https://readdy.ai/api/search-image?query=Advanced%20regenerative%20medicine%20clinic%20with%20exosome%20therapy%20treatments%2C%20medical%20professionals%20administering%20stem%20cell%20derived%20exosome%20injections%20for%20aesthetic%20and%20therapeutic%20applications%2C%20modern%20medical%20facility%20with%20sophisticated%20treatment%20rooms%2C%20patient%20consultation%20areas%20and%20medical%20equipment%20for%20regenerative%20procedures&width=600&height=256&seq=exosome-medical-clinic-2024&orientation=landscape"
                  alt="医療応用"
                  className="w-full h-48 object-cover rounded-lg"
                />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-gray-800">医療・治療分野</h3>
              <p className="text-gray-700 mb-6 leading-relaxed">
                再生医療の補完治療として、様々な疾患・症状の改善をサポート
              </p>
              
              <div className="space-y-4">
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h4 className="font-bold text-lg mb-2 text-teal-600">美容医療</h4>
                  <p className="text-sm text-gray-600">フェイシャル注射、ダーマペン併用治療</p>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h4 className="font-bold text-lg mb-2 text-teal-600">整形外科</h4>
                  <p className="text-sm text-gray-600">関節炎、軟部組織損傷の修復促進</p>
                </div>
                <div className="bg-white rounded-lg p-4 shadow-md">
                  <h4 className="font-bold text-lg mb-2 text-teal-600">皮膚科</h4>
                  <p className="text-sm text-gray-600">創傷治癒、アトピー性皮膚炎の改善</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Research & Development Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-teal-50">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-gray-800">
                継続的な研究開発
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Exosome Oneは、エクソソーム技術のさらなる発展を目指し、<strong>国内外の研究機関との共同研究</strong>を積極的に推進しています。
              </p>
              
              <div className="space-y-6">
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-flask-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-gray-800">基礎研究</h3>
                    <p className="text-gray-600 text-sm">エクソソーム内容物の解析、作用機序の解明</p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-test-tube-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-gray-800">応用研究</h3>
                    <p className="text-gray-600 text-sm">新しい疾患への治療応用、効果検証</p>
                  </div>
                </div>
                
                <div className="flex gap-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-2xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold mb-2 text-gray-800">国際連携</h3>
                    <p className="text-gray-600 text-sm">海外研究機関との共同プロジェクト推進</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="relative">
              <div className="w-full h-96 overflow-hidden rounded-2xl shadow-2xl">
                <img
                  src="https://readdy.ai/api/search-image?query=International%20collaborative%20research%20laboratory%20with%20scientists%20from%20different%20countries%20working%20together%20on%20exosome%20research%2C%20modern%20biotechnology%20facility%20with%20global%20communication%20screens%20showing%20research%20data%2C%20diverse%20team%20of%20researchers%20analyzing%20stem%20cell%20derived%20extracellular%20vesicles%2C%20advanced%20scientific%20equipment%20and%20international%20research%20partnership%20meeting%20rooms&width=600&height=400&seq=international-exosome-research-2024&orientation=landscape"
                  alt="国際共同研究"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Quality & Safety Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-800">
            品質管理と安全性
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-shield-check-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">GMP準拠</h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                医薬品製造品質管理基準に準拠した製造プロセスで、最高レベルの品質を保証
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-microscope-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">品質検査</h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                電子顕微鏡、ウエスタンブロット、フローサイトメトリーによる多角的品質評価
              </p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-file-shield-line text-4xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold mb-4 text-gray-800">安全性試験</h3>
              <p className="text-gray-700 text-sm leading-relaxed">
                細胞毒性、感作性、刺激性試験により、安全性を科学的に検証
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-purple-600 to-pink-600 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            エクソソーム（エキソソーム）事業に関するお問い合わせ
          </h2>
          <p className="text-lg mb-8 opacity-95">
            エクソソーム（エキソソーム）原料の供給、OEM・ODM、共同研究に関するご相談は、<br />
            お気軽にお問い合わせください。専門スタッフが詳しくご説明いたします。
          </p>
          <Link 
            to="/contact" 
            className="inline-flex items-center gap-3 bg-white text-purple-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transition-colors shadow-xl cursor-pointer whitespace-nowrap"
          >
            <i className="ri-mail-line text-2xl"></i>
            お問い合わせ
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}